export const CONTACT_DETAILS_FORM_NAME = 'contactDetails';
export const CONTACT_DETAILS_FIRST_NAME_FIELD = 'firstName';
export const CONTACT_DETAILS_LAST_NAME_FIELD = 'lastName';
export const CONTACT_DETAILS_EMAIL_FIELD = 'email';
export const CONTACT_DETAILS_PHONE_FIELD = 'phone';

export const CONTACT_DETAILS_INITIAL_STATE = {
    [CONTACT_DETAILS_FIRST_NAME_FIELD]: {
        value: '',
        isValid: true,
        errorMessage: null,
    },
    [CONTACT_DETAILS_LAST_NAME_FIELD]: {
        value: '',
        isValid: true,
        errorMessage: null,
    },
    [CONTACT_DETAILS_EMAIL_FIELD]: {
        value: '',
        isValid: true,
        errorMessage: null,
    },
    [CONTACT_DETAILS_PHONE_FIELD]: {
        value: '',
        isValid: true,
        errorMessage: null,
    },
};
